import { invokeApi } from "../bl_libs/invokeApi";

export const contact_us_api = async (data) => {
  const requestObj = {
    path: `api/partner/contact_us`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};